import { Wrapper, Text } from "./EmptyMessage";

export const EmptyMessage = () => {
  return (
    <Wrapper>
      <Text>There are any numbers...</Text>
    </Wrapper>
  );
};
